var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "upgrade-needed-page", class: { limited: _vm.limited } },
    [
      _c("div", { staticClass: "upgrade-needed-page-title" }, [
        _c(
          "div",
          { staticClass: "upgrade-needed-page-image" },
          [_c("UpgradeSVG")],
          1
        ),
        _vm._v(" "),
        _vm.limited
          ? _c("div", [
              _vm._v(_vm._s(_vm.$t("upgradeMessages.usageLimitExceeded"))),
            ])
          : _c("div", [
              _vm._v(
                '"' +
                  _vm._s(_vm.getPageName()) +
                  '" ' +
                  _vm._s(_vm.$t("upgradeMessages.featureNotAvailable"))
              ),
            ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "upgrade-needed-page-description" }, [
        _vm._v("\n        " + _vm._s(_vm.getPageDescription()) + "\n    "),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "upgrade-needed-page-subscription" },
        [
          _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.upgrade } },
            [_vm._v(_vm._s(_vm.$t("upgradeMessages.upgrade")))]
          ),
          _vm._v(" "),
          _vm.feature && !_vm.limited
            ? _c(
                "SupsisButton",
                { attrs: { ghost: "" }, on: { click: _vm.upgradeFeature } },
                [_vm._v(_vm._s(_vm.$t("upgradeMessages.upgradeFeature")))]
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }